import { Formik, FormikProps } from 'formik';
import React from 'react';
import { useIntl } from 'react-intl';
import validationSchemaForRecommendationFeedback from './Validation';
import { ContactViewTabs } from '@amzn/aet-contactrecommendation-kit';
import { convertEnumToObject } from '../../../../Util';
import {
  ConsolidatedContact,
  ContactDetailsInput,
  ContactRecommendationsData,
  ContactViewTabType,
  RecommendedContactStatusOptionsType,
  GoodRecommendationOptionsObject,
} from '../../../../api/CoachingNotes/schema';

import ContactReviewFeedbackModalFormContent from './ContactReviewFeedbackModalFormContent';

export const ContactViewTabObject = convertEnumToObject(ContactViewTabs);

interface ContextFeedbackModalFormWrapperProps {
  onsubmit: Function;
  prevStatus: RecommendedContactStatusOptionsType;
  contactId: string;
  week: number;
  year: number;
  username: string;
  userid: string;
  parentValues: ConsolidatedContact | ContactRecommendationsData;
  contactTab?: ContactViewTabType;
  contactCategory?: string;
  ingress?: string | null;
}

export const ContextFeedbackModalFormWrapper = ({
  onsubmit,
  prevStatus,
  contactId,
  userid,
  contactCategory,
  ingress,
}: ContextFeedbackModalFormWrapperProps): React.ReactElement => {
  const handleSubmit = async (values: ContactDetailsInput): Promise<void> => {
    const contactReviewFeedbackDetails: ContactDetailsInput = {
      goodRecommendation: values.goodRecommendation,
      uncoachableReason: values.uncoachableReason,
      justification: values.justification,
    };

    onsubmit(contactReviewFeedbackDetails);
  };
  return (
    <Formik
      initialValues={{
        goodRecommendation: GoodRecommendationOptionsObject.YES,
        justification: '',
      }}
      onSubmit={handleSubmit}
      validationSchema={validationSchemaForRecommendationFeedback(useIntl())}
    >
      {/* @ts-ignore */}
      {(props: FormikProps<ContactDetailsInput>): React.ReactElement => (
        <ContactReviewFeedbackModalFormContent
          {...props}
          status={prevStatus}
          contactId={contactId}
          userId={userid.split(':')[1]}
          contactCategory={contactCategory}
          ingress={ingress}
        />
      )}
    </Formik>
  );
};

export default ContextFeedbackModalFormWrapper;
